module.exports = __webpack_public_path__ + "static/media/WebText_SpecialMove_Prinny2_1.6d048f3c.png";